/* eslint-disable no-undef */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-fallthrough */
/* eslint-disable no-unused-expressions */

'use strict';

const base = require('base:product/detail');
const attributesLogic = require('attributes');
const recommendationsLogic = require('../components/recommendations');
require('slick-carousel');

/**
* Creates a modal HTML element with the current slide index
* @param {number} currentSlide - the current slide index
*/
function getModalHtmlElement(currentSlide) {
    if ($('#detailImageModal').length !== 0) {
        $('#detailImageModal').remove();
    }
    var htmlString = '<!-- Modal -->'
        + '<div class="modal fade" id="detailImageModal" role="dialog">'
        + '<div class="carousel-info sr-only" data-initial-index=' + currentSlide + '></div>'
        + '<div class="modal-dialog detail-image-dialog">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + '    <button type="button" class="close pull-right" data-dismiss="modal">'
        + '        <span class="close-btn"></span>'
        + '    </button>'
        + '</div>'
        + '<div class="modal-body"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
}

/**
* Parses HTML and returns the body element
* @param {string} html - HTML string to parse
* @returns {Object} - an object containing the body element
*/
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.primary-images');

    return { body: body };
}

/**
* Fills the modal element with the selected value URL
* @param {string} selectedValueUrl - the URL of the selected value
*/
function fillModalElement(selectedValueUrl) {
    $('.modal-body')
        .spinner()
        .start();
    $.ajax({
        url: selectedValueUrl,
        method: 'GET',
        dataType: 'json',
        success: function (data) {
            var parsedHtml = parseHtml(data.renderedTemplate);

            $('.modal-body')
                .empty()
                .html(parsedHtml.body);
            $('#detailImageModal').modal('show');
            $('body').trigger('detailimage:ready');
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * @param {string} attributeName 'orc_color' or 'orc_size'
 * @param {string} attrDataAttrID 'data-attr'
 * @param {Object} attributeValues element object
 * @returns {boolean} true if a value has already been selected for the attributeName, false otherwise
 */
function isAttributeSelected(attributeName, attrDataAttrID, attributeValues) {
    // eslint-disable-next-line no-shadow
    const attribute = Object.values(attributeValues).find(function (attributeValues) {
        return attributeValues.attributes[attrDataAttrID].value == attributeName;
    });

    return Object.values(attribute.children).some(function (child) {
        return Object.values(child.classList).some(function (className) {
            return Object.is(className, 'circle-selected');
        });
    });
}

/**
 * Adjust the add-to-cart button text depending on the value of COLOR and SIZE attribute
 * @param {Object} event event
 */
function updateAddToCartButton(event) {
    const attrDataAttrID = 'data-attr';
    const attrVariationTextChoose = 'data-text-choose';
    const COLOR = 'orc_color';
    const SIZE = 'orc_size';

    const $target = $(event.currentTarget);

    const attributeID = $target.closest('.attribute-values').attr(attrDataAttrID);
    const buttonAddToCart = $target.parentsUntil('.product-detail-container').find('.add-to-cart-custom-btn');
    const attributeValues = $target.parentsUntil('row.variation-attributes').find('.attribute-values');

    switch (attributeID) {
        case COLOR:
            (!isAttributeSelected(SIZE, attrDataAttrID, attributeValues))
                ? buttonAddToCart.attr(attrVariationTextChoose, () => appData.resources.CHOOSE_SIZE)
                : buttonAddToCart.attr(attrVariationTextChoose, () => appData.resources.ADD_TO_CART);
        case SIZE:
            (!isAttributeSelected(COLOR, attrDataAttrID, attributeValues))
                ? buttonAddToCart.attr(attrVariationTextChoose, () => appData.resources.CHOOSE_COLOR)
                : buttonAddToCart.attr(attrVariationTextChoose, () => appData.resources.ADD_TO_CART);
        default:
            (!isAttributeSelected(COLOR, attrDataAttrID, attributeValues))
                ? buttonAddToCart.attr(attrVariationTextChoose, () => appData.resources.CHOOSE_COLOR)
                : (!isAttributeSelected(SIZE, attrDataAttrID, attributeValues))
                    ? buttonAddToCart.attr(attrVariationTextChoose, () => appData.resources.CHOOSE_SIZE)
                    : buttonAddToCart.attr(attrVariationTextChoose, () => appData.resources.ADD_TO_CART);
    }
}

/**
* Initializes product detail logic
*/
function initProductDetailLogic() {
    $(function () {
        $('.attributes .attribute.toggle').on('click', attributesLogic.toggleAttribute);
        $('.attribute-values .circle-unselected').on('click', function (e) {
            if ($(e.currentTarget).hasClass('circle-selected') === false) {
                attributesLogic.selectAttributeValue(e);
                updateAddToCartButton(e);
            }
        });

        recommendationsLogic.initRecommandationLogic();

        $('.club-subscription-link').on('click', function () {
            var encodedUrl = $(this).attr('data-cbo');
            var showMoreUrl = decodeURIComponent(window.atob(encodedUrl));
            window.location.href = showMoreUrl;
        });
    });
}

/**
* Updates the add to cart button and other elements based on the product availability
* @param {Object} e - Event object
* @param {Object} response - Response object containing the product container and product object
*/
function updateAddToCartCustom() {
    $('body').on('product:updateAddToCart', function (e, response) {
        // If the user clicks on a variation that is already selected, no need to update
        if ($(e.currentTarget).hasClass('circle-selected') === false) {
            // update local add to cart (for sets)
            const $addToCartButton = $('button.add-to-cart', response.$productContainer);
            const disableButton = (!response.product.readyToOrder || !response.product.available);

            $addToCartButton.attr('disabled', disableButton);

            if (disableButton) {
                $addToCartButton.text($addToCartButton.attr('data-text-choose'));
            } else {
                $addToCartButton.text($addToCartButton.attr('data-text-ready'));
            }

            var enable = $('.product-availability').toArray().every(function (item) {
                return $(item).data('available') && $(item).data('ready-to-order');
            });
            base.methods.updateAddToCartEnableDisableOtherElements(!enable);
        }
    });
}

/**
* Aligns swatches for color and size attributes on product detail page
*/
function pdpdSwatchAlign() {
    var $aligncolorSwatch = $('.variation-attributes div[data-attr="orc_color"] .attribute-values');
    var $alignsizeSwatch = $('.variation-attributes div[data-attr="orc_size"] .attribute-values');
    if ($aligncolorSwatch.find('.circle-attribute').length > 6) {
        $aligncolorSwatch.addClass('center-align');
    }
    if ($alignsizeSwatch.find('.circle-attribute').length > 6) {
        $alignsizeSwatch.addClass('center-align');
    }
} pdpdSwatchAlign();

/**
* Closes the popin modal when the specified event data is received.
*
* @param {Object} evt - The event object containing data about the event.
* @param {string} evt.data - The data associated with the event, expected to be 'close' to trigger the popin closure.
*/
function closeEReservationPopin(evt) {
    if (evt.data === 'close') {
        // close the popin
        $('#eReservation').modal('hide');
        let $eReservationIframe = $('#eReservation iframe');
        $eReservationIframe.attr('src', $eReservationIframe.attr('src'));
    }
}

module.exports = {
    ...base,
    ...{
        initProductDetailLogic,
        /**
        * Handles click events on product detail images and modal elements
        */
        showProductDetailImageModal: function () {
            $('body').on('click', '.slick-slide', function () {
                var index = $(this).data('slick-index');
                $(this)
                    .closest('.slick-slider')
                    .attr('data-current-slide', index);
            });
            $('body').on('click', '.product-detail-image-modal', function (e) {
                e.preventDefault();

                if (window.app.isMobile()) {
                    return;
                }

                var encodedUrl = $(this).attr('data-cbo');
                var selectedValueUrl = decodeURIComponent(window.atob(encodedUrl));
                $(e.target).trigger('detailimage:show');
                var currentSlide = $(this)
                    .closest('.slick-slider').find('.slick-current')
                    .data('slick-index');
                getModalHtmlElement(currentSlide);
                fillModalElement(selectedValueUrl);
            });
        },
        updateAddToCart: updateAddToCartCustom,

        /**
        * Initializes the carousel in the detail image modal
        * @param {Object} $modal - The jQuery object of the detail image modal
        * @param {number} currentSlide - The initial slide index
        * @param {Object} $carousel - The jQuery object of the carousel
        */
        initDetailImageModal: function () {
            $('body').on('shown.bs.modal', '#detailImageModal', function () {
                var $modal = $('#detailImageModal');
                var currentSlide = $modal.find('.carousel-info').data('initial-index');
                var $carousel = $modal.find('.carousel-inner');

                $carousel.slick({
                    initialSlide: currentSlide,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false,
                    arrows: true
                });
            });
        },
        /**
        * Initializes the eReservation modal functionality, allowing users to reserve items in-store.
        *
        * This function sets up an event listener on the body element to display the eReservation modal
        * when elements with the class 'js-reserve-in-store' are clicked. It also listens for messages
        * from other windows to close the modal when a 'close' message is received.
        *
        * @listens {jQuery.Event} click - Triggers the display of the eReservation modal.
        * @listens {MessageEvent} message - Listens for messages to close the modal.
        * @param {Object} evt - The event object containing data about the event.
        * @param {string} evt.data - The data associated with the event, expected to be 'close' to trigger the popin closure.
        */
        EReservationModal: function () {
            let $eReservation = $('#eReservation');

            if ($eReservation.length) {
                $('body').on('click', '.js-reserve-in-store', function () {
                    $eReservation.modal('show');
                });

                if (window.addEventListener) {
                    window.addEventListener('message', closeEReservationPopin, false);
                } else {
                    window.attachEvent('onmessage', closeEReservationPopin);
                }

                $('body').on('hidden.bs.modal', '#eReservation', function () {
                    closeEReservationPopin({ data: 'close' });
                });
            }
        }
    }
};
